module.exports = __webpack_public_path__ + "media/control_acceso/barrera_automatica_labeled-9c2b0aa7.png";